// IE Hub - Token Utilities
// Client-side token validation and management

export interface TokenInfo {
  isValid: boolean;
  isExpired: boolean;
  payload?: any;
}

/**
 * Decode JWT token without verification (client-side validation only)
 */
export function decodeToken(token: string): any {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

/**
 * Check if token is valid and not expired
 */
export function validateToken(token: string | null): TokenInfo {
  if (!token) {
    return { isValid: false, isExpired: true };
  }

  const payload = decodeToken(token);
  if (!payload) {
    return { isValid: false, isExpired: true };
  }

  const now = Math.floor(Date.now() / 1000);
  const isExpired = payload.exp && payload.exp < now;

  return {
    isValid: !isExpired,
    isExpired: !!isExpired,
    payload
  };
}

/**
 * Get stored auth tokens
 */
export function getStoredTokens() {
  return {
    accessToken: localStorage.getItem('authToken'),
    refreshToken: localStorage.getItem('refreshToken')
  };
}

/**
 * Check if user has valid authentication
 */
export function hasValidAuth(): boolean {
  const { accessToken } = getStoredTokens();
  const tokenInfo = validateToken(accessToken);
  return tokenInfo.isValid;
}
